import { render, staticRenderFns } from "./AfterBefore.vue?vue&type=template&id=7878aa58&scoped=true"
import script from "./AfterBefore.vue?vue&type=script&lang=js"
export * from "./AfterBefore.vue?vue&type=script&lang=js"
import style0 from "./AfterBefore.vue?vue&type=style&index=0&id=7878aa58&prod&scoped=true&lang=css"
import style1 from "./AfterBefore.vue?vue&type=style&index=1&id=7878aa58&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7878aa58",
  null
  
)

export default component.exports